import React, { useEffect, useRef, useState } from 'react';
import { Helpers } from '../../../Helpers';

function AggregateFormItem({ aggregate_list, storeData, setStoreData, sectionIndex,
    currentCurrencyData, taxAmount, setTaxAmount, rowTax, setRowTax,
    isOverallTax, discountPercentage, setDiscountPercentage }) {
    let aggregateList = storeData?.data?.[sectionIndex]?.section_data?.aggregate_list || {};
    let tableData = storeData.data[sectionIndex]?.section_data?.table_data || [];

    let storeAggregateValue = (key, value, directAssignVale = null) => {
        setStoreData(prevData => ({
            ...prevData,
            data: prevData.data.map((item, index) =>
                index === sectionIndex
                    ? {
                        ...item,
                        section_data: {
                            ...item.section_data,
                            ...(directAssignVale ? { aggregate_list: directAssignVale } : { aggregate_list: { ...item.section_data?.aggregate_list, [key]: value } })
                        }
                    }
                    : item
            )
        }));
    };

    const convertStrFormula = (formula) => {
        if (typeof formula === 'string')
            return formula.replace(/[\d.,\s]+/g, (match) => {
                let cleaned = match.replace(/\s/g, '');
                if (cleaned.match(/[.,]*,\d+$/)) {
                    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
                }
                else if (cleaned.match(/,\d{3}/) && cleaned.includes('.')) {
                    cleaned = cleaned.replace(/,/g, '');
                }
                else if (cleaned.match(/,\d{3}/)) {
                    cleaned = cleaned.replace(/,/g, '');
                }
                const num = parseFloat(cleaned);
                return Number.isNaN(num) ? match : num.toString();
            });
        else
            return formula
    }

    let getAggregateValue = (item) => {
        let { aggregate_function, subform_field } = item?.extra_fields || {};
        let values = tableData.map(x => Number(convertStrFormula(x?.[Helpers.replaceData(subform_field)]))).filter(Boolean);
        let val = 0;
        if (values.length > 0) {
            switch (aggregate_function) {
                case "SUM":
                    val = values.reduce((acc, curr) => acc + curr, 0);
                    break;
                case "MIN":
                    val = Math.min(...values);
                    break;
                case "MAX":
                    val = Math.max(...values);
                    break;
                case "AVG":
                    val = values.reduce((acc, curr) => acc + curr, 0) / values.length;
                    break;
                default:
                    val = 0;
            }
        }
        return val || 0;
    };

    let getFormulaValue = (item, data) => {
        let calculatedValue = 0; let calculatedDiscValue = 0;

        if (data?.Sub_Total && discountPercentage !== "" && discountPercentage !== "0") {
            calculatedDiscValue = data?.Sub_Total * Number(discountPercentage) / 100
            if (calculatedDiscValue > 0) {
                data['Discount'] = calculatedDiscValue
            }
        }

        if (data?.Sub_Total && data?.Tax) {
            if (data?.Tax > 0) {
                calculatedValue = ((data?.Sub_Total - Number(data?.Discount || 0)) * (1 + Number(data?.Tax) / 100))
                calculatedValue = calculatedValue - (data?.Sub_Total - Number(data?.Discount || 0))
                if (calculatedValue > 0) {
                    setTaxAmount(calculatedValue)
                }
            } else {
                setTaxAmount('0')
            }
        } else {
            setTaxAmount('')
        }

        let expression = item?.extra_fields?.formula_expression;
        let calculateFormula = (formula, product) => (
            formula?.replace(/\${(.*?)}/g, (match, variable) => {
                let keys = variable?.split('.');
                return product?.[Helpers.replaceData(keys?.[1])] || 0;
            })
        );
        if (Object.keys(data).length > 0) {
            let processedFormula = calculateFormula(expression, data);
            let result = eval(processedFormula);
            return result;
        }
        return 0;
    };

    let getDiscFormulaValue = (item, data, value) => {
        let calculatedValue = 0;
        if (data?.Sub_Total && value !== "" && value !== "0") {
            setDiscountPercentage(value)
            calculatedValue = data?.Sub_Total * Number(value) / 100
            if (calculatedValue > 0) {
                return calculatedValue;
            }
        } else {
            setDiscountPercentage('')
        }
        return 0;
    };

    let handleBlurEvent = () => {
        let data = { ...aggregateList }
        for (let x of aggregate_list) {
            if (x?.input_type === "formula") {
                let result = getFormulaValue(x, data);
                data[Helpers.replaceData(x?.extra_fields?.field_label)] = result;
            }
        }
        storeAggregateValue("", "", data);
    };

    const updateRowTax = () => {
        setRowTax(prevData =>
            prevData.map(item => ({
                ...item,
                tax_type: 'percentage'
            }))
        );
    }

    useEffect(() => {
        if (aggregate_list?.length > 0) {
            let data = { ...aggregateList };
            for (let x of aggregate_list) {
                if (x?.input_type === "aggregate") {
                    let result = getAggregateValue(x);
                    data[Helpers.replaceData(x?.extra_fields?.field_label)] = result;
                } else if (x?.input_type === "formula") {
                    let result = getFormulaValue(x, data);
                    data[Helpers.replaceData(x?.extra_fields?.field_label)] = result;
                }
            }
            storeAggregateValue("", "", data);
        }
    }, [tableData]);

    const formatNumber = (amount) => {
        return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
            style: "decimal",
            minimumFractionDigits: currentCurrencyData?.decimal_place,
            maximumFractionDigits: currentCurrencyData?.decimal_place,
        }).format(amount);
    };

    // dp

    const inputRef = useRef(null);
    const [fieldWidth, setFieldWidth] = useState(0);

    useEffect(() => {
        if (inputRef.current) {
            setFieldWidth(inputRef.current.offsetWidth);
        }
    }, []);

    const updateTaxCalculation = () => {
        let updatedStoreData = JSON.parse(JSON.stringify(storeData));
        let updatedAggregateList = updatedStoreData.data[sectionIndex].section_data['aggregate_list']
        if (updatedAggregateList) {
            updatedAggregateList['Tax'] = ""
            updatedStoreData.data[sectionIndex].section_data["aggregate_list"] = updatedAggregateList;
            setStoreData(updatedStoreData);
        }
        setTaxAmount('')
    }

    useEffect(() => {
        if (!isOverallTax) {
            updateTaxCalculation();
        }
    }, [isOverallTax])

    const handleDicountPercentage = () => {
        let data = { ...aggregateList }
        for (let x of aggregate_list) {
            if (x?.input_type === "aggregate") {
                let result = getDiscFormulaValue(x, data, discountPercentage);
                data['Discount'] = result;
            }
            if (x?.input_type === "formula") {
                let result = getFormulaValue(x, data);
                data[Helpers.replaceData(x?.extra_fields?.field_label)] = result;
            }
        }
        storeAggregateValue("", "", data);
    }

    return (
        <div className="row ms-0 pe-0">
            {aggregate_list?.map((x, index) => (
                <div key={index} className="col-md-4 offset-md-8 d-flex justify-content-end mt-3">
                    <div className="form-floating">
                        {/* {x?.input_type === "aggregate" && (
                            <input
                                type="text"
                                className="form-control"
                                placeholder={x?.label}
                                value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                readOnly
                            />
                        )} */}
                        {x?.input_type === "aggregate" &&
                            <>
                                {x?.extra_fields?.field_label === "Sub Total" ?
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={x?.label}
                                        value={formatNumber(aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)]) || ''}
                                        readOnly
                                    />
                                    :
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={x?.label}
                                        value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                        readOnly
                                    />
                                }
                            </>
                        }
                        {/* {x?.input_type === "formula" && (
                            <input
                                type="text"
                                className="form-control"
                                placeholder={x?.label}
                                value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                readOnly
                            />
                        )} */}
                        {x?.input_type === "formula" &&
                            <>
                                {x?.extra_fields?.field_label === "Grant Total" ?
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={x?.label}
                                        value={formatNumber(aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)]) || ''}
                                        readOnly
                                    />
                                    :
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={x?.label}
                                        value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                        readOnly
                                    />
                                }
                            </>
                        }
                        {x?.input_type === "number" && (
                            <input
                                type="number"
                                className="form-control"
                                placeholder={x?.label}
                                value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                onChange={(e) => storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value)}
                                onBlur={handleBlurEvent}
                            />
                        )}
                        {x?.input_type === "decimal" && (
                            <input
                                type="number"
                                className="form-control"
                                placeholder={x?.label}
                                value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                onChange={(e) => storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value)}
                                onBlur={handleBlurEvent}
                                step="any"
                            />
                        )}
                        {x?.input_type === "currency" &&
                            <>
                                {x?.extra_fields?.field_label === "Tax" ?
                                    (<>
                                        <div className="d-flex float-end" style={{ width: `${fieldWidth}px` }}>
                                            <div className="form-floating w-35">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder={x?.label}
                                                    value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                                    onChange={(e) => { updateRowTax(); storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value) }}
                                                    onBlur={handleBlurEvent}
                                                    step="any"
                                                    disabled={isOverallTax ? false : true}
                                                />
                                                <label className={`d-inline-block`} htmlFor={x?.id}>
                                                    {x?.extra_fields?.field_label + ' %'}
                                                </label>
                                            </div>
                                            <div className="form-floating w-65 ms-1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={x?.label}
                                                    value={formatNumber(taxAmount)}
                                                    readOnly
                                                    disabled={isOverallTax ? false : true}
                                                // value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                                // onChange={(e) => storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value)}
                                                // onBlur={handleBlurEvent}
                                                // step="any"
                                                />
                                                <label className={`d-inline-block`} htmlFor={x?.id}>
                                                    Tax Amount
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                    ) : x?.extra_fields?.field_label === "Discount" ? (
                                        // <input
                                        //     type="number"
                                        //     className="form-control"
                                        //     placeholder={x?.label}
                                        //     value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                        //     onChange={(e) => storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value)}
                                        //     onBlur={handleBlurEvent}
                                        //     step="any"
                                        // />
                                        <>
                                            <div className="d-flex float-end" style={{ width: `${fieldWidth}px` }}>
                                                <div className="form-floating w-35">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder={x?.label}
                                                        value={discountPercentage}
                                                        // disabled={isOverallTax ? false : true}
                                                        onChange={(e) => setDiscountPercentage(e.target.value)}
                                                        onBlur={handleDicountPercentage}
                                                    />
                                                    <label className={`d-inline-block`} htmlFor={x?.id}>
                                                        {x?.extra_fields?.field_label + ' %'}
                                                    </label>
                                                </div>
                                                <div className="form-floating w-65 ms-1">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder={x?.label}
                                                        value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                                        onChange={(e) => { storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value); setDiscountPercentage('') }}
                                                        onBlur={handleBlurEvent}
                                                        step="any"
                                                    // disabled={isOverallTax ? false : true}
                                                    />
                                                    <label className={`d-inline-block`} htmlFor={x?.id}>
                                                        Amount
                                                    </label>
                                                </div>
                                            </div>
                                        </>
                                    ) :
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder={x?.label}
                                            value={aggregateList?.[Helpers.replaceData(x?.extra_fields?.field_label)] || ''}
                                            onChange={(e) => storeAggregateValue(Helpers.replaceData(x?.extra_fields?.field_label), e.target.value)}
                                            onBlur={handleBlurEvent}
                                            step="any"
                                            ref={inputRef}
                                        />
                                }
                            </>
                        }
                        {(x?.extra_fields?.field_label !== "Tax" && x?.extra_fields?.field_label !== "Discount") &&
                            <label className={`d-inline-block`} htmlFor={x?.id}>
                                {x?.extra_fields?.field_label}
                            </label>
                        }
                    </div>
                </div>
            ))
            }
        </div >
    );
}

export default AggregateFormItem;
